import { gql } from '@apollo/client';

export const AllUsersQuery = gql`
  query AllUsers {
    allUsers {
      id
      firstName
      lastName
      email
      role
      status
      canBrowseNas
      hasDriverLicence
      parentId
      parent {
        id
        firstName
        lastName
        email
      }
      children {
        id
        firstName
        lastName
        email
        status
      }
      childInvite {
        id
        parentEmail
        expiresAt
      }
      profile {
        gender
        dateOfBirth
        license
        pictureThumbnail
        weights {
          value
        }
        files {
          id
        }
      }
      rentals {
        id
        returnDate
      }
      contributions {
        seasonId
        paidAt
      }
      securityDeposits {
        seasonId
        paidAt
      }
    }
  }
`;

export const FindOneUserQuery = gql`
  query FindOneUser($email: String!) {
    findOneUser(email: $email) {
      id
      firstName
      lastName
      email
      status
      role
      canBrowseNas
      profile {
        id
        bio
        dateOfBirth
        license
        grade
        locationOfBirth
        address
        phone
        pictureThumbnail
        gender
        nationality
        rlType
        rlFirstName
        rlLastName
        rlAddress
        rlPhone
        rlEmail
        weights {
          id
          value
          createdAt
        }
        files {
          id
          name
        }
      }
      events {
        event {
          id
          name
          level
          startAt
          endAt
          location
          categories
        }
        achievements {
          category
          rank
          weightCategory
          mode
        }
      }
      rentals {
        id
        rentalDate
        returnDate
        depositPaid
        depositReturned
        rentalComment
        rentalPicture
        returnComment
        returnPicture
        bag {
            id
            name
            qrCode
            depositAmount
            equipments {
                equipment {
                    id
                    name
                    size
                }
            }
        }
      }
    }
  }
`;

export const GET_COACHES = gql`
  query GetCoaches {
    users(where: { role: { equals: "COACH" } }) {
      id
      firstName
      lastName
    }
  }
`;

export const GET_DRIVERS = gql`
  query GetDrivers {
    allUsers {
      id
      firstName
      lastName
      role
      status
      profile {
        files {
          id
          type
        }
      }
    }
  }
`;

export const MyChildrenQuery = gql`
  query MyChildren {
    myChildren {
      id
      firstName
      lastName
      email
    }
  }
`;

export const CHECK_CHILD_INVITE = gql`
  query CheckChildInvite($token: String!) {
    checkChildInvite(token: $token) {
      childFirstName
      childLastName
      parentEmail
      parentAlreadyExists
    }
  }
`;

export const DRIVER_LICENCE_FOR_USER = gql`
  query DriverLicenceForUser($userId: Int!) {
    driverLicenceForUser(userId: $userId) {
      id
      name
      file
      createdAt
    }
  }
`;
